import { MagicSearchItemTextProps } from '../magic-search-palette.type';

export const MagicSearchItemText = ({ title, legacyId, lines }: MagicSearchItemTextProps) => (
  <span className='flex min-w-0 flex-1 flex-col'>
    <span className='flex min-w-0 items-baseline gap-2'>
      <span className='truncate text-subtitle-s text-primary' data-testid='magic-search-item--title'>
        {title}
      </span>
      <span className='shrink-0 text-body-xs text-tertiary' data-testid='magic-search-item--legacy-id'>
        #{legacyId}
      </span>
    </span>
    {lines
      .map((line) => line.filter(Boolean).join(' · '))
      .filter(Boolean)
      .map((line, index) => (
        <span key={index} className='truncate text-body-xs text-tertiary'>
          {line}
        </span>
      ))}
  </span>
);
